export const normalizeLocationName = name => name.replace(/\.|'/g, '').toLowerCase();

// Add any other locations requiring normalization as discovered
export const NORMALIZED_LOCATIONS = [
  {
    canonicalSlug: 'st-johns',
    searchValue: 'st. john\'s',
  },
];
